import React from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';

const TableBox = ({
    evaluateInfos: {
        dataList = [],
        pageNum,
        pageSize,
        resultTotal
    },
    onPageChange,
    onTableOperate,
}) => {

    const onOperateCell = (id, record) => {
        return <div className={styles.action}>
            <div
                className={styles.item}
                onClick={() => onTableOperate(id, record)}
            >编辑</div>
        </div>;
    };

    const scoreCell = (text, record) => {
        if (Number(text) > 0) {
            return tooltip(`+${text}`);
        } else {
            return tooltip(text);
        }
    };

    const columns = [
        {
            title: '评价星级',
            dataIndex: 'appraiseTypeId',
            key: 'appraiseTypeId',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text) => (<div>{tooltip(`${text}星`)}</div>)
        },
        {
            title: '评价标签',
            dataIndex: 'label',
            key: 'label',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '等级分值',
            dataIndex: 'levelScore',
            key: 'levelScore',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: scoreCell
        },
        {
            title: '排序',
            dataIndex: 'sortNo',
            key: 'sortNo',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={onPageChange}
        />
    </div>;
};

TableBox.propTypes = {
    onPageChange: PropTypes.func,//分页变化
    evaluateInfos: PropTypes.object,//表格数据
    onTableOperate: PropTypes.func,//表格操作
};
export default TableBox;